import { render } from "./IntergovExpensesEditView.vue?vue&type=template&id=2abcf4ae&scoped=true"
import script from "./IntergovExpensesEditView.vue?vue&type=script&lang=js"
export * from "./IntergovExpensesEditView.vue?vue&type=script&lang=js"

import "./IntergovExpensesEditView.vue?vue&type=style&index=0&id=2abcf4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abcf4ae"]])

export default __exports__